import React from 'react';
import styled from 'styled-components/macro';

const StyledHeader = styled.div<{ noMargin: boolean; customWidth?: string }>`
  text-align: left;
  margin-bottom: ${({ noMargin }) => (noMargin ? 0 : '20px')};
  width: ${({ customWidth }) => (customWidth ? customWidth : '')};
`;

interface Props {
  title: string;
  subtitle?: string;
  noMargin?: boolean;
  customWidth?: string;
}

const Title = styled.h2`
  color: ${({ theme }) => theme.colorPalette.grey.grey7};
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: ${({ theme }) => theme.fontSizePalette.xLarge};
  font-weight: ${({ theme }) => theme.fontWeightPalette.light};
  margin-bottom: 5px;
  letter-spacing: -0.75px;
  line-height: 28px;
  max-width: 600px;
`;

export const Subtitle = styled.h3`
  color: ${({ theme }) => theme.colorPalette.grey.grey9};
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: ${({ theme }) => theme.fontSizePalette.medium};
  font-weight: ${({ theme }) => theme.fontWeightPalette.light};
  letter-spacing: -0.5px;
  line-height: 19px;
`;

const Header = (props: Props) => {
  const { noMargin = false, customWidth } = props;

  return (
    <StyledHeader customWidth={customWidth} noMargin={noMargin} className="modalHeader">
      <Title>{props.title}</Title>
      {props.subtitle && <Subtitle>{props.subtitle}</Subtitle>}
    </StyledHeader>
  );
};

export default Header;
